import api from './apiClient';

export const tshirtSizesAPI = {
  getTshirtSizes: async (raceId, raceTypeId?) => {
    const params: Record<string, any> = {};
    if (raceTypeId) params.raceTypeId = raceTypeId;
    const response = await api.get(`/api/races/${raceId}/tshirt-sizes`, { params });
    return response.data;
  },
  createTshirtSize: async (raceId, data) => {
    const response = await api.post(`/api/races/${raceId}/tshirt-sizes`, data);
    return response.data;
  },
  updateTshirtSize: async (id, data) => {
    const response = await api.post(`/api/tshirt-sizes/${id}`, data);
    return response.data;
  },
  deleteTshirtSize: async (id) => {
    await api.post(`/api/tshirt-sizes/${id}/delete`, {});
  },
};
